<section class="content-panel-b container-fluid">
  <div class="content-full">
    <div style="width: 100%;" [ngClass]="{'resume-sticky': screenWidth > 939}">
      <mat-card class="configuration-card"
      [ngClass]=" (disable || !deadlineSelect) && !resultOfRequestNotSuccess() && stateSelected?.stateName!==null ? 'disabled-panel' : ''">
        <div class="sticky-mobile">

          <app-resume-quoter
            [ngClass]=" (disable || !deadlineSelect) && !resultOfRequestNotSuccess() ? 'disabled-panel' : ''"
            textHeader="Resumen" 
            [showTitle]="true" 
            [isCredit]="true" 
            [brand]="car.brand" 
            [subBrand]="car.subBrand"
            [version]="car.version" 
            [year]="car.year" 
            [priceWithIva]="car.priceWithIva"
            [stateName]="stateSelected?.stateName" 
            [period]="deadlineSelect?.period"
            [initialPayment]="deadlineSelect?.initialPayment" 
            [monthlyPayment]="deadlineSelect?.monthlyPayment"
            [insurance]="insuranceSelected.insurance?.key" 
            [purchaseValue]="false" 
            [isMaxPurchaseValue]="false"
            [appliedCode]="codeStatus === 'valid'"
            [concept]="productType === 'TRADITIONAL' ? flagAnual ? 'Crédito tradicional anualidades' : 'Crédito tradicional': 'Crédito Ballon'"
            [isBallon]="productType !== 'TRADITIONAL'" 
            [isDropDown]="screenWidth < 768"
            [hitch]="deadlineSelect?.downPayment" 
            [annuity]="deadlineSelect?.annuity"
            [rate]="deadlineSelect?.finalRate?.finalRate" 
            [ballon]="dataQuoter?.ballon"
            [cat]="deadlineSelect?.cat"></app-resume-quoter>

          <div style="display: flex; flex-direction:column;align-items:center;">
            <div class="container-btn-autorize" style="width: 80% !important;">
              <button (click)="preauthorize()" [disabled]="resultOfRequestNotSuccess() || !deadlineSelect"
                mat-raised-button id="boton-autorizar-plan">¡QUIERO AUTORIZAR MI PLAN!
              </button>
            </div>

            <div class="container-btn-compare" style="width: 80% !important;">
                <button id="boton-comparar-unidad{{'-' + productType}}" (click)="compare()"
                  [disabled]="resultOfRequestNotSuccess() || !deadlineSelect" mat-raised-button>Comparar unidad</button>
            </div>
          </div>

          <div [ngClass]=" (disable || !deadlineSelect) && !resultOfRequestNotSuccess() ? 'disabled-panel' : ''">
            <div class="container-btn-autorize codepromo">
              <button (click)="showCode = !showCode">Tengo un código promocional</button>
            </div>
            <div class="animate__animated  animate__fadeInDown" *ngIf="showCode">
              <h3>Código promocional</h3>
              <div class="content-error-codigo" *ngIf="codeStatus !== 'valid'">
                <div class="error-codigo" *ngIf="codeStatus === 'invalid'">
                  Código de promoción no válido. El código de promoción que ingresaste no existe.
                </div>
                <div class="error-codigo" *ngIf="codeStatus === 'novalidity'">
                  Código de promoción sin vigencia. El código de promoción que ingresaste ha vencido.
                </div>
                <div class="error-codigo" *ngIf="codeStatus === 'inactive'">
                  Código de promoción inactivo. El código de promoción que ingresaste se encuentra inactivo.
                </div>
                <div class="triangle" *ngIf="codeStatus !== '' && codeStatus !== 'valid'"></div>
              </div>
              <div class="content-input content-input-code-promotion">
                <mat-form-field floatLabel='never' class="input-codigo">
                  <input id="inputCodigo" matInput type="text" maxlength="16" placeholder="Introduce aquí tu código"
                    [(ngModel)]="codePromo" (keyup)="keyupInputCode()" />
                  <mat-icon class="icon-check" *ngIf="codeStatus === 'valid'" matSuffix>check_circle</mat-icon>
                </mat-form-field>

                <div class="container-btn-code">
                  <button id="boton-aplicar-codigo" (click)="applyCode()"
                    [disabled]="resultOfRequestNotSuccess() || !deadlineSelect || !codePromo"
                    mat-raised-button>Aplicar</button>
                </div>
              </div>
              <div class="content-change-code" *ngIf="codeStatus === 'valid'">
                <span class="change-code" (click)="changeCode()">
                  <span class="text-change">Cambiar código</span>
                  <mat-icon class="icon-change">cached</mat-icon>
                </span>
              </div>
            </div>
          </div>

          <div class="container-btn-file">
            <app-pdf-credit *ngIf="deadlineSelect" [car]="car" [dataQuoter]="dataQuoter"
              [deadlineSelect]="deadlineSelect" [stateSelected]="stateSelected"
              [insuranceSelected]="insuranceSelected"></app-pdf-credit>
          </div>

        </div>

        <mat-card-content class="content-config scroll-gray">
          <div [ngClass]="{'focus-cp': stateSelected?.stateName===null}">
            <h3 class="title-cp" align="center">{{ 'CREDIT.quoter.cp' | translate }}</h3>
            <div class="content-input content-input-cp">
              <mat-form-field floatLabel='never' class="input-cp" tourAnchor="step.one">
                <input [(ngModel)]="codePostal" id="inputCodigoPostal" matInput mask="00000" inputmode="numeric"
                  minlength="5" maxlength="5" (keyup)="keyupInputCodePostal($event.target)" #inputCodigoPostal placeholder="00000"/>
              </mat-form-field>
              <h3 class="mt-1">{{stateSelected?.stateName}}</h3>
            </div>
          </div>

          <hr>

          <div [ngClass]=" (disable || !deadlineSelect) && !resultOfRequestNotSuccess() ? 'disabled-panel' : ''">

            <div tourAnchor="step.two">

              <h3>{{ 'CREDIT.quoter.hitch' | translate }}</h3>

              <div class="content-slider slider-configuration">
                <ngx-slider class="slider" [value]="valueHitch" [options]="optionsHitch"
                  (userChangeEnd)="hitchChange($event); interactionUser()"></ngx-slider>
                <span class="slider-input">$ <input type="number" class="form-control" [min]="hitchPriceFloor"
                    [max]="hitchPriceCeil" step="1000" [(ngModel)]="valueHitch" [ngModelOptions]="{standalone: true}"
                    (change)="changeInputHitch($event);"></span>
              </div>
            </div>

            <hr>


            <ng-container *ngIf="productType === 'TRADITIONAL'">
              <!-- TODO: FASE 2 -->
              <div tourAnchor="step.three">
                <mat-slide-toggle [(ngModel)]="flagAnual" (change)="changeToggle(5, $event)" >
                  Incluir pagos anuales
                </mat-slide-toggle>
              </div>
              <!-- TODO: FASE 2 -->
              <div class="content-month">
                <ng-container *ngIf="flagAnual">
                  Mes:
                  <mat-form-field class="select-config" appearance="fill">
                    <mat-select placeholder="Selecciona la entidad en que radicas" [(value)]="valueAnnuityPaymentMonth"
                      disableRipple disableOptionCentering
                      (selectionChange)="selectAnnualPaymentMonth($event.value, true); interactionUser()">
                      <mat-option class="select-options" *ngFor="let month of months; index as i"
                        [value]="month.id"> {{month.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </ng-container>
              </div>

              <div class="content-slider slider-configuration" *ngIf="flagAnual">
                <ngx-slider class="slider" [value]="annuityValue" [options]="optionsAnnuity"
                  (userChangeEnd)="annuityChange($event);"></ngx-slider>
                <span class="slider-input">$ <input type="number" class="form-control" [min]="annuityFloor"
                    [max]="annuityCeil" [step]="500" [(ngModel)]="annuityValue" [ngModelOptions]="{standalone: true}"
                    (change)="changeInputAnnuity($event);"></span>
              </div>
            </ng-container>

            <ng-container *ngIf="productType === 'BALLON'" >
              <div tourAnchor="step.threeB">
                <h3> Pago final </h3>
                <div class="content-slider slider-configuration">
                  <ngx-slider class="slider" [value]="valueBallon" [options]="optionsBallon"
                    (userChangeEnd)="ballonChange($event);"></ngx-slider>
                  <span class="slider-input"><input type="number" class="form-control" [min]="ballonFloor"
                      [max]="ballonCeil" [step]="0.1" [(ngModel)]="valueBallon" [ngModelOptions]="{standalone: true}"
                      (change)="changeInputBallon($event);"> &nbsp;%</span>
                </div>
              </div>
            </ng-container>
            <hr>

            <mat-accordion class="accordion-plus">
              <mat-expansion-panel hideToggle (opened)="showDetails = true" (closed)="showDetails = false">
                <mat-expansion-panel-header>
                  <div class="container-tool">
                    <div> Personaliza tu plan </div>
                    <div>{{ showDetails ? 'Ocultar detalles' : 'Ver detalles' }} </div>
                  </div>
                </mat-expansion-panel-header>
                <div class="container-desc">
                  <div class="content-text">
                    <span>
                      <strong> PROTECCIÓN PLUS: </strong> {{personalizaStrappi?.proteccion_plus_text}}
                      <img class="icon-play" id="boton-play-video-proteccion-plus" src="./assets/home/play.svg"
                        alt="img-play"
                        (click)="summaryService.openVideo(personalizaStrappi.proteccion_plus_video, 'Video info Protección plus')">
                    </span>
                  </div>

                  <!-- TODO: FASE 2 -->
                  <div class="content-text">
                    <span>
                      <strong> AUTO SUSTITUTO: </strong> {{personalizaStrappi?.auto_sustituto_text}}
                      <img class="icon-play" id="boton-play-video-auto-sustituto" src="./assets/home/play.svg"
                        alt="img-play"
                        (click)="summaryService.openVideo(personalizaStrappi.auto_sustituto_video, 'Video info Auto sustituto')">
                    </span>
                  </div>
                  <div class="content-text">
                    <span>
                      <strong> RASTREO BASE: </strong> Te brindamos la localización satelital de tu vehículo con acción
                      en caso de robo
                    </span>
                  </div>
                  <div class="content-text">
                    <span>
                      <strong> MANTENIMIENTO: </strong> Incluye la cobertura de un determinado número de servicios de
                      mantenimiento de carnet de acuerdo al kilometraje seleccionado.
                    </span>
                  </div>
                  <!-- TODO: FASE 2 -->
                </div>
              </mat-expansion-panel>
            </mat-accordion>

            <app-loading-spinner diameter="45px"
              *ngIf="loadingServicesPlus;else showServicesPlus"></app-loading-spinner>
            <ng-template #showServicesPlus>
              <mat-slide-toggle [(ngModel)]="flagProtectionPlus" (change)="changeToggle(1, $event)">
                Protección Plus + ${{costProtectionPlus | number : '1.2-2'}} / mes
              </mat-slide-toggle>
              <!-- TODO: FASE 2 -->
              <mat-slide-toggle class="disabled-section" [(ngModel)]="flagSubstituteCar" [disabled]="flagAutoSuRequired" (change)="changeToggle(2, $event)">
                Auto Sustituto + ${{costSubstituteCar}} / mes
              </mat-slide-toggle>
              <ng-container *ngIf="flagSubstituteCar">
                <h3 class="disabled-section">Auto Sustituto</h3>
                <mat-form-field class="select-config" appearance="fill" class="disabled-section">
                  <mat-select placeholder="Selecciona el tipo de auto" [(value)]="valueSubstituteCar" [disabled]="flagAutoSusRequired" disableRipple
                    disableOptionCentering (selectionChange)="substituteCarSelect($event.value); interactionUser()">
                    <mat-option class="select-options" *ngFor="let item of optionsSubstituteCar" [value]="item.value">
                      {{item.text}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>

              <div tourAnchor="step.four" class="disabled-section">
                <mat-slide-toggle [(ngModel)]="flagGps" [disabled]="flagGpsRequired" (change)="changeToggle(4, $event)">
                  Incluir rastreo base
                </mat-slide-toggle>
              </div>

              <ng-container *ngIf="hasMaintenance">
                <div tourAnchor="step.five" class="disabled-section">
                  <mat-slide-toggle [(ngModel)]="flagMaintenance" (change)="changeToggle(3, $event)">
                    Incluir mantenimientos
                  </mat-slide-toggle>
                </div>
                <div *ngIf="flagMaintenance" class="disabled-section">
                  <br />
                  <mat-form-field class="select-config" appearance="fill" *ngIf="KmArray.length !== 0">
                    <mat-select [(value)]="defaultKm" disableRipple disableOptionCentering
                      (selectionChange)="kmSelect($event.value); interactionUser()">
                      <mat-option class="select-options" *ngFor="let km of KmArray" [value]="km">{{ km }}
                        Km</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </ng-container>
              <!-- TODO: FASE 2 -->

            </ng-template>

            <hr>

            <!-- TODO: FASE 2 -->
            <div class="content-ingresos" *ngIf="!hasDefaultUserType" class="disabled-section">
              <ng-container>
                ¿Tienes forma de comprobar ingresos?
                <mat-form-field class="select-config" appearance="fill">
                  <mat-select [(value)]="checkIncomeValue" placeholder="" disableRipple disableOptionCentering
                    (selectionChange)="checkIncomesChanges($event.value); interactionUser()">
                    <mat-option class="select-options" *ngFor="let checkIncome of checkIncomes;"
                      [value]="checkIncome.value">{{checkIncome.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </ng-container>
            </div>
            <hr class="disabled-section">
            <!-- TODO: FASE 2 -->


            <mat-accordion class="accordion-plus">
              <mat-expansion-panel hideToggle (opened)="showDetailsSecure = true" (closed)="showDetailsSecure = false">
                <mat-expansion-panel-header>
                  <div class="container-tool">
                    <div>
                      Seguro del auto: <span>{{insuranceSelected.insurance?.key}}</span>
                    </div>
                    <div>{{ showDetailsSecure ? 'Ocultar detalles' : 'Ver detalles' }} </div>
                  </div>
                </mat-expansion-panel-header>
                <div class="container-desc mt-2">
                  <div class="content-text">
                    <span>
                      <strong> DE CONTADO: </strong> Paga el monto total de tu póliza al inicio del contrato para reducir tu mensualidad.
                    </span>
                  </div>
                  <div class="content-text">
                    <span>
                      <strong> MULTIANUAL FINANCIADO: </strong> El monto total de tu póliza será financiado durante la duracción del plazo seleccionado.
                    </span>
                  </div>
                </div>
              </mat-expansion-panel>

            </mat-accordion>

            <br>
            <mat-form-field class="select-config" appearance="fill">
              <mat-select placeholder="Selecciona el tipo de seguro" [(value)]="valueInsuranceType" disableRipple
                disableOptionCentering (selectionChange)="insuranceTypeSelect($event.value); interactionUser()">
                <ng-container *ngFor="let insuranceType of optionsInsuranceType">
                  <mat-option class="select-options" *ngIf="insuranceType.active"
                    [value]="insuranceType.id">
                    {{insuranceType.name}}</mat-option>
                  </ng-container>
                </mat-select>
            </mat-form-field>

            <div class="text-center" *ngIf="completedResponses === totalInsuranceResponses && insurances.length!==0">
              <button class="btn-change-insurre"
                [ngClass]=" completedResponses === totalInsuranceResponses && insurances.length > 1 ? 'change-button' : '' " mat-raised-button
                [disabled]="resultOfRequestNotSuccess()" (click)="openDialog()">
                Cambiar aseguradora
              </button>
            </div>

            <div id="noSecureInfo" class="container-loading p-1" *ngIf="completedResponses === totalInsuranceResponses && insurances.length===0">
              <span class="text-center"> 
                El precio del seguro para este vehículo te será confirmado durante el proceso
              </span>
            </div> 

            <div id="insurances-better" *ngIf="completedResponses === totalInsuranceResponses && insurances.length > 1 ">
              <div>
                <span class="active-process active"> </span>
              </div>
              <div>
                <p> Hemos encontrado
                  {{ validateBetter() ? ' una opción de aseguradora más barata' : ' otras opciones de aseguradora másbarata' }}
                  para ti. </p>
              </div>
            </div>

            <div id="search" class="container-loading p-1" *ngIf="completedResponses !== totalInsuranceResponses ">
              <span class="text-center"> Estamos buscando las mejores opciones de aseguradoras para ti </span>
              <app-loading-spinner diameter="45px"></app-loading-spinner>
            </div>

            <div class="alert-danger-custom container-loading p-1" *ngIf="resultOfRequestNotSuccess()" #notInsurances>
              <span class="text-center">
                Lamentablemente no hay aseguradoras en la Entidad seleccionada para este auto.
                Te invitamos a contactarnos vía correo o WhatsApp para hacerte llegar de forma manual la cotización o
                bien, a cotizar otra unidad
              </span>
              <br>
              <label>
                <mat-icon class="icon-size info" [inline]="true"> mail_outline </mat-icon>
                <a [href]="emailTipTo"> {{ emailTip }} </a>
              </label>
              <label>
                <mat-icon class="icon-size info" [inline]="true"> phone </mat-icon>
                <a [href]="whatsTip" target="_blank"> WhatsApp </a>
              </label>
            </div>

            <hr>
            <div class="container-btn-compare">
                <button id="boton-comparar-unidad{{'-' + productType}}" (click)="compare()"
                  [disabled]="resultOfRequestNotSuccess() || !deadlineSelect" mat-raised-button>Comparar unidad</button>
            </div>
            <div class="container-btn-autorize">
              <button (click)="preauthorize()" [disabled]="resultOfRequestNotSuccess() || !deadlineSelect"
                mat-raised-button id="boton-autorizar-plan">¡QUIERO AUTORIZAR MI PLAN!</button>
            </div>
            <!-- <app-deadline-table-credit *ngIf="screenWidth < 768" [isAfin]="false"></app-deadline-table-credit> -->
          </div>

          <app-share-link-credit 
            [pageUrl]="'/cotizador-credito/' + slashedUrl + '?quote='"
            [dataQuoter]="dataQuoter" 
            [deadlineSelect]="deadlineSelect"
            carTitle="¡He visto este {{car.brand}} {{car.subBrand}} en" 
            [metaUrl]="metaUrl"></app-share-link-credit>

        </mat-card-content>
      </mat-card>
    </div>
  </div>


  <div class="loading-calculate" *ngIf="(disable || !deadlineSelect) && !resultOfRequestNotSuccess()">
      <app-loading-spinner diameter="110px" title="Por favor espera estamos cargando los plazos..."></app-loading-spinner>
    </div>

</section>